import axios from "axios";

import {
  ALLAPPS,
  AUDIENCEAPI,
  AUDIENCECONTACTUS,
  AUDIENCEFBSUCESS,
  AUDIENCEPAYMENTS,
  AUDIENCEPERFORMANCEAPI,
  AUDIENCEPRODUCTDATA,
  CHECKAUDIENCEDATA,
  CONTACTUSAPI,
  CREATEAPP,
  FETCHTABDATA,
  GETAPPDETAILS,
  GETAPPLISTPAGEDATA,
  GETAPPREVIEWS,
  GETCOUPONS,
  LOGOUT,
  NAVBARAPPLISTING,
  POSTAPPRATING,
  POSTINSTALLAPP,
  POSTINSTALLAPP2,
  POSTPERMISSIONAPPROVAL,
  SUBSCRIPTION_CREATE,
  SUBSCRIPTION_VERIFY,
  VERFYPAYMENT,
  VERIFYTOKEN,
  ISVALIDADACCOUNTID,
} from "./endpoint";
import axiosInstance from "../axiosInstance";

const axiosInstanceTracking = axios.create({});
const urls = process.env.REACT_APP_LOG_OUT;
axiosInstanceTracking.interceptors.request.use((config) => {
  const env = process.env.REACT_APP_ENV;

  const token = localStorage.getItem("satellizer_token");
  if (env == "production") {
    config.params = {
      ...config.params,
      app_id: "1",
      company_id: "1",
    };
    config.headers["Authorization"] = "Bearer " + token;
  }
  config.params = {
    ...config.params,
    app_id: "1",
    company_id: "1",
  };
  if (config?.data?.Content) {
    config.headers["Content-Type"] = config?.data?.Content;
  } else {
    config.headers["Content-Type"] = "application/json";
  }
  config.headers["Access-Control-Allow-Origin"] = "*";

  config.headers["Authorization"] = "Bearer " + token;
  return config;
});

axiosInstanceTracking.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response.data;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error.response.data);
  }
);

// export const getDeveloperDashboardAppListing = async () => {
//   return axiosInstance.get(GETUSERDETAILS());
// };

export const getUserDetailDashboard = async () => {
  return axiosInstance.get(GETAPPLISTPAGEDATA());
};

export const getNaaBarAppListing = async () => {
  return axiosInstance.get(NAVBARAPPLISTING());
};

export const getAllAppsDashboard = async (pageNumber) => {
  return axiosInstance.get(ALLAPPS(pageNumber));
};

export const tokenverfy = async (data: any) => {
  return axiosInstance.post(VERIFYTOKEN(), data);
};
export const postCreateAPP = async () => {
  return axiosInstance.post(CREATEAPP());
};

export const getAppInfo = async (slug) => {
  return axiosInstance.get(GETAPPDETAILS(slug));
};

export const postInstallApp = async () => {
  return axiosInstance.post(POSTINSTALLAPP());
};
export const getAppReview = async (app_id, page) => {
  return axiosInstance.get(GETAPPREVIEWS(app_id, page));
};
export const postAppRating = async () => {
  return axiosInstance.post(POSTAPPRATING());
};

export const logOut = async (data: any, token: any) => {
  return axiosInstance.post(await LOGOUT(data, token));
};

export const postInstallApp2 = async () => {
  return axiosInstance.post(POSTINSTALLAPP2());
};

export const postPermission = async () => {
  return axiosInstance.post(POSTPERMISSIONAPPROVAL());
};

export const subscriptionVerify = async (token) => {
  return axiosInstance.post(SUBSCRIPTION_VERIFY(token));
};
export const subscriptionCreate = async () => {
  return axiosInstance.post(SUBSCRIPTION_CREATE());
};

export const Contactusapi = async (data: any) => {
  return axiosInstance.post(CONTACTUSAPI(), data);
};

export const audienceApi = async (data: any) => {
  return axiosInstance.post(AUDIENCEAPI(), data);
};

export const getAudiencePerformanceData = async (data) => {
  return axiosInstance.get(AUDIENCEPERFORMANCEAPI(data));
};

export const checkAudienceData = async () => {
  return axiosInstance.get(CHECKAUDIENCEDATA());
};
export const audienceContactUs = async (data) => {
  return AUDIENCECONTACTUS(data);
};

export const audienceProductData = async (type) => {
  return AUDIENCEPRODUCTDATA(type);
};
export const audiencepayment = async (data: any) => {
  return AUDIENCEPAYMENTS(data); // Call and return AUDIENCEPAYMENTS directly
};
export const verfyPayment = async (data: any) => {
  return VERFYPAYMENT(data); // Call and return AUDIENCEPAYMENTS directly
};

export const audienceFbConnectSucess = async (data: any) => {
  return axiosInstance.post(AUDIENCEFBSUCESS(), data);
};
export const fetchtabData = async () => {
  return axiosInstance.get(FETCHTABDATA());
};

export const getAudienceCoupons = async () => {
  return axiosInstance.get(GETCOUPONS());
};

export const checkAdaccount = async (data) => {
  return axiosInstance.get(ISVALIDADACCOUNTID(data));
};